import type { Cart } from '@cobrastyle/shared-types';

/**
 * The cart's total as the cart page and mini cart should show it: what the customer owes for the
 * goods, without shipping.
 *
 * Magento keeps the shipping method from an earlier checkout visit (or one Svea auto-selected), so
 * `grandTotal` can already include a freight cost the cart surfaces never itemise. Subtracting the
 * selected method's `amount` would be fragile: the adapter does not say whether that figure is
 * incl. or excl. VAT, and it is absent when only the grand total carries the cost. Building the
 * figure up from `subtotalIncludingTax` less the discounts needs neither, and is correct with
 * prices-include-tax because both are already tax-inclusive figures.
 */
export function cartTotalExcludingShipping(
  totals: Pick<Cart['totals'], 'subtotalIncludingTax' | 'discounts' | 'grandTotal'>,
): number {
  const discount = totals.discounts.reduce((sum, d) => sum + d.amount, 0);
  return Math.max(0, totals.subtotalIncludingTax - discount);
}
